import React, { useEffect, useState } from "react";
import styles from "../../assets/css/admin/layout.module.css"
import "../../assets/css/admin/allAdmins.module.css"
import SideBar from "./SideBar";
import axios from "axios";
import { baseUrl } from "../../baseUrl";
import swal from "sweetalert";
import moment from "moment";
import {useAuth} from "../../AuthContext"
import { useSidebar } from "../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close'
import { Link } from "react-router-dom";
import api from "../../api";


const AllInquiries = () => {
    const { logout, user } = useAuth();
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    const [allInquiries, setAllInquiries] = useState([])
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [totalEnquiries, setTotalEnquiries] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [currentMessage, setCurrentMessage] = useState("");

    const getAllInquiries = async (pageNum=page, limit= entriesPerPage) => {
        try {
            const res = await api.get(`${baseUrl}/contact/all-inquiries?page=${pageNum}&limit=${limit}`)
            setAllInquiries(res.data.inquiries)
            setTotalPages(res.data.totalPages);
            setTotalEnquiries(res.data.total);
        } catch (e) {
            console.log(e)
        }
    }
    useEffect(() => {
        getAllInquiries(page, entriesPerPage)
    }, [page, entriesPerPage])

    const deleteInquiry = (p) => {
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    api.post(`${baseUrl}/contact/inquiry/delete?id=${p._id}`)
                        .then(res => {
                            getAllInquiries()
                            swal(`${res.data.message}`, {
                                icon: "success",
                            });
                        }
                        )
                        .catch(err=>{
                            swal(`${err.response.data.message}`, {
                                icon: "error",
                            })
                        })
                }
            });
    }

    const renderPageNumbers = () => {
        const pages = [];
        const visibleRange = 2;
    
        let start = Math.max(1, page - visibleRange);
        let end = Math.min(totalPages, page + visibleRange);
    
        if (start > 1) {
          pages.push(1);
          if (start > 2) pages.push("…");
        }
    
        for (let i = start; i <= end; i++) {
          pages.push(i);
        }
    
        if (end < totalPages) {
          if (end < totalPages - 1) pages.push("…");
          pages.push(totalPages);
        }
    
        return pages.map((num, i) =>
          num === "…" ? (
            <span key={i} className="mx-1">…</span>
          ) : (
            <button
              key={i}
              onClick={() => setPage(num)}
              className={`btn btn-sm mx-1 ${num === page ? "btn-primary" : "btn-outline-primary"}`}
            >
              {num}
            </button>
          )
        );
      };
    const openModal = (message) => {
        setCurrentMessage(message);
        setShowModal(true);
    };

    // Function to close the modal
    const closeModal = () => {
        setShowModal(false);
        setCurrentMessage("");
    };
    return (
        <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
            <aside className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}>
                <SideBar />
            </aside>

            <main className={styles.mainContent}>
            <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
                <nav aria-label="breadcrumb" >
                    <ol className="breadcrumb">
                        <div className="d-flex flex-grow-1">
                            <li className="breadcrumb-item">
                                <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                Inquiries
                            </li>
                        </div>
                        <li className="nav-item dropdown">
                            <span
                                className="nav-link dropdown-toggle"
                                data-bs-toggle="dropdown"
                                href=""
                                role="button"
                                aria-expanded="false"
                            >
                                Welcome, {user.name}
                                <i className="ml-2 fa fa-angle-down"></i>
                            </span>
                            <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                                <li>
                                    <span className="dropdown-item" onClick={logout}>
                                        Logout
                                    </span>
                                </li>
                            </ul>
                        </li>
                    </ol>
                </nav>
                <div
                    className="container"
                    style={{ backgroundColor: "white", padding: "40px" }}
                >
                    <h4 className="mb-4"> All Enquiries</h4>
                    <div style={{overflowX:'scroll'}}>
                        <table>
                            <thead>
                                <tr>
                                    <td>Name</td>
                                    <td>Email</td>
                                    <td>Subject</td>
                                    <td>Date</td>
                                    <th>Message</th>
                                    <td>Action</td>
                                </tr>
                            </thead>
                            <tbody>
                                {allInquiries.length > 0 &&
                                    allInquiries.map((p, i) => (
                                        <tr key={i}>
                                            <td>{p.name}</td>
                                            <td>{p.email}</td>
                                            <td>{p.subject}</td>
                                            <td>{moment(p.createdAt).format("MMMM Do YYYY, h:mm:ss a")}</td>
                                            <td>
                                            <button
                                                    onClick={() => openModal(p.message)}
                                                    className="btn btn-info btn-sm"
                                                >
                                                    Show
                                                </button>
                                            </td>
                                            <td>
                                                <button onClick={() => deleteInquiry(p)} className="btn btn-danger btn-sm m-1">Delete</button>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="d-flex flex-wrap justify-content-between align-items-center mt-3">
                        <div className="d-flex flex-wrap gap-3">
                        <div>Showing page {page} of {totalPages} ({totalEnquiries} entries)</div>
                        <div>
                            <label className="me-2">Entries per page:</label>
                            <select
                                value={entriesPerPage}
                                onChange={(e) => {
                                    setEntriesPerPage(Number(e.target.value));
                                    setPage(1);
                                }}
                            >
                                {[5, 10, 20, 50].map(size => (
                                    <option key={size} value={size}>{size}</option>
                                ))}
                            </select>
                        </div>
                        </div>
                        <div>
                            <button
                                className="btn btn-outline-primary btn-sm mx-1"
                                onClick={() => setPage(p => Math.max(p - 1, 1))}
                                disabled={page === 1}
                            >
                                Prev
                            </button>
                            {renderPageNumbers()}
                            <button
                                className="btn btn-outline-primary btn-sm mx-1"
                                onClick={() => setPage(p => Math.min(p + 1, totalPages))}
                                disabled={page === totalPages}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </main>
            {showModal && (
                <div className="modal" style={modalStyles.overlay}>
                    <div className="modal-content" style={modalStyles.content}>
                        <span
                            className="close"
                            style={modalStyles.close}
                            onClick={closeModal}
                        >
                            &times;
                        </span>
                        <h5>Message</h5>
                        <p>{currentMessage}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AllInquiries

const modalStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
    },
    content: {
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "8px",
        maxWidth: "600px",
        width: "100%",
        maxHeight: "400px",
        overflowY: "auto",
    },
    close: {
        position: "absolute",
        top: "10px",
        right: "10px",
        fontSize: "30px",
        cursor: "pointer",
    },
};
